(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/tickets-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/tickets-wheel.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const TicketCard = svs.eInstant.components.TicketCard;
const TicketsWheel = _ref => {
  let games = _ref.games,
    numberedList = _ref.numberedList,
    onChange = _ref.onChange;
  const containerRef = useRef(null);
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  useEffect(() => {
    var _containerRef$current;
    const wrappers = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll('.slider-item-wrapper');
    if (wrappers && wrappers[activeIndex]) {
      wrappers[activeIndex].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [activeIndex]);
  return React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
    }
  }, React.createElement("div", {
    className: "ticket-card-slider-container u-flex",
    ref: containerRef
  }, games.map((game, index) => React.createElement("label", {
    className: "slider-item-wrapper",
    key: game.cntTicketGameId
  }, React.createElement("input", {
    "aria-label": "Spel ".concat(index + 1, " av ").concat(games.length),
    checked: activeIndex === index,
    className: "tickets-einstant-ticket-card-radio",
    onChange: () => {
      setActiveIndex(index);
      onChange && onChange(game, index);
    },
    type: "radio"
  }), React.createElement("div", {
    className: index === 0 ? 'margin-h-1' : 'margin-right-1'
  }, React.createElement(TicketCard, {
    hasFocus: activeIndex === index,
    isNumberedList: numberedList,
    number: index + 1,
    ticketConfig: game
  }))))));
};
setGlobal('svs.eInstant.components.TicketsWheel', TicketsWheel);

 })(window);